import React, { useState } from "react";
import ScrollToTop from "../ScrollToTop";
import TeamsSection from "../Teams Page Components/TeamsSection";
import Footer2 from "../Footer Components/Footer2";
import Navbar2 from "../Nav Components/Navbar2";
import Sidebar2 from "../Sidebar2";
import TeamsHero from "../Teams Page Components/TeamsHero";

const TeamsPage = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };
  return (
    <>
    <Sidebar2 isOpen={isOpen} toggle={toggle} />
      <ScrollToTop />
      <Navbar2 toggle={toggle} />
      <TeamsHero />
      <TeamsSection showProfileText />
      <Footer2 />
    </>
  );
};
export default TeamsPage;
